export enum DocumentSearchMode {
  Dossier = 'dossier',
  Registry = 'registry',
  Assignment = 'assignment'
}
